import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAuditLog extends Layout {
    sourceAuditLogTx: DataSource;
    tableAuditLog: Table;
}
